import { AUTH_HEADERS } from '@libs/core/constants';
import {
    getAccessToken,
    getChatbotEnabled,
    getChatbotModel,
    getChatbotReasoning,
    getVisitorId,
} from '@libs/core/cookies';

export function chatHeaders() {
    const accessToken = getAccessToken();
    const visitorId = getVisitorId();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const chatbotEnabled = getChatbotEnabled();
    const reasoning = getChatbotReasoning();
    const model = getChatbotModel();

    return {
        ...(accessToken && { [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${accessToken}` }),
        ...(visitorId && { [AUTH_HEADERS.X_PETM_VISITOR_ID]: visitorId }),
        ...(timeZone && { [AUTH_HEADERS.X_PETM_TIMEZONE]: timeZone }),
        ...(chatbotEnabled && { [AUTH_HEADERS.X_PETM_CHATBOT_ENABLED]: 'true' }),
        ...(reasoning && { [AUTH_HEADERS.X_PETM_CHATBOT_REASONING]: reasoning }),
        ...(model && { [AUTH_HEADERS.X_PETM_CHATBOT_MODEL]: model }),
    };
}
